import React from 'react';
import { Typography } from '@mui/material';
import PolicyHeader from './PolicyHeader';
import Policy from './Policy';
import CommonMapFunction from './CommonMapFunction';
import { dataOne, dataTwo, aboutListData } from './AboutUsData';
import { companyDetails } from 'utils/companyDetails';


function AboutUs() {
  const searchParams = new URLSearchParams(window.location.search);
  const isMobileParams = searchParams.get('isMobile') === 'true';
  return (
    <div>
      {!isMobileParams && <PolicyHeader/>}
      <div className="aboutBackground">
      { !isMobileParams &&<Typography className="headerText justifyCenter fw500 pt20 pb30">
          About {companyDetails?.companyName}
        </Typography>}
        <CommonMapFunction data={dataOne} />
        <Policy policyData={aboutListData} />
        <CommonMapFunction data={dataTwo} />
        <div className="mb20">
          <Typography variant="head5" className="fw500">
            Get in Touch
          </Typography>
          <Typography variant="body2" className="fw400">
            We value your feedback and suggestions. Feel free to reach out to
            our customer support team through the app or by visiting our website
            at &nbsp;
            <span>
              <a href="https://iter.co.in/" target="_blank">
                https://iter.co.in/
              </a>
            </span>
          </Typography>
        </div>

        <div className="mb20">
          <Typography variant="head5" className="fw500">
            Together, let's keep India moving!
          </Typography>
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
